import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
/**
 * UsageDonut - a small color-coded ring showing how full something is (0-1).
 *
 * Generic by design: the only input is a fraction, so it can meter context
 * windows, quotas, storage, etc. Color band (ok / warn / danger) is derived
 * from the warn/danger thresholds and applied via a modifier class - never an
 * inline color, per the styling rules. The arc fill is the one dynamic value,
 * passed as a stroke-dashoffset on a unit (circumference=100) circle so
 * geometry stays in SVG coordinate space, not CSS px literals.
 */
export function UsageDonut({ ratio, warnAt = 0.75, dangerAt = 0.95, ariaLabel, className, }) {
    const clamped = Math.min(1, Math.max(0, ratio));
    const pct = Math.round(clamped * 100);
    const band = clamped >= dangerAt ? 'danger' : clamped >= warnAt ? 'warn' : 'ok';
    // r chosen so the circumference is ~100, letting dashoffset = 100 - pct.
    const RADIUS = 15.9155;
    const dashOffset = 100 - clamped * 100;
    return (_jsxs("svg", { className: clsx('usage-donut', `usage-donut--${band}`, className), viewBox: "0 0 36 36", role: "img", "aria-label": ariaLabel ?? `${pct}% full`, children: [_jsx("circle", { className: "usage-donut__track", cx: "18", cy: "18", r: RADIUS }), _jsx("circle", { className: "usage-donut__fill", cx: "18", cy: "18", r: RADIUS, strokeDasharray: "100", strokeDashoffset: dashOffset })] }));
}
//# sourceMappingURL=UsageDonut.js.map